import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledButton = styled(Button)({
  marginBottom: 0,
  fontSize: 14,
  height: 36.5,
});
